import React from "react";
import { Typography } from "@mui/material";
import PageLayout from "@layouts/PageLayout";

const UnautorizedPage: React.FC = () => {
  return (
    <PageLayout dir="ltr">
      <div className="h-[calc(100vh-64px)] flex justify-center items-center">
        <div className="">
          <Typography variant="h4" className="text-center">
            Unauthorized Access
          </Typography>
          <Typography className="text-center">
            You do not have permission to view this page.
          </Typography>
        </div>
      </div>
    </PageLayout>
  );
};

export default UnautorizedPage;
